import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// users
import user1 from "../../../assets/images/users/AdminImg.png"
import configure from "configure"
import secureLocalStorage from "react-secure-storage"
import { getInitials } from "utils/common-helpers"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [username, setusername] = useState("Admin")

  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.displayName)
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = JSON.parse(localStorage.getItem("authUser"))
        setusername(obj.username)
      }
    }
  }, [props.success])
  const user = secureLocalStorage.getItem('User')
  const navigate = useNavigate();

  const onLogout = () => {
    secureLocalStorage.removeItem("User")
    secureLocalStorage.removeItem("Token")
    secureLocalStorage.removeItem("tutorial")
    navigate(`${configure.appUrl}/login`)
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item text-white "
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="d-flex align-items-center">
            {/* <img
            className="rounded-circle header-profile-user border-0"
            src={user1}
            alt={user?.company}
            style={{ objectFit: "cover" }}
          /> */}
            <span
              className="defualt-img"
              title={user.company}
            >
              {getInitials(user.company)}
            </span>
            <span className="d-none d-xl-inline-block ms-2 me-1">{user?.company}</span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <a className="dropdown-item" onClick={() => onLogout()}>
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </a>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
